export class ResultCodeConstant {
  public static SUCCESS_CODE = '00';
  public static SUCCESS_CODE2 = 200;
}
